import { NzNotificationService } from "ng-zorro-antd/notification";

import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class NotificationService extends NzNotificationService {}
